import { render } from "./StepView.vue?vue&type=template&id=08ea8158&scoped=true"
import script from "./StepView.vue?vue&type=script&lang=js"
export * from "./StepView.vue?vue&type=script&lang=js"

import "./StepView.vue?vue&type=style&index=0&id=08ea8158&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ea8158"]])

export default __exports__